<template>
    <div class="article-faqs-tile-covid">
        <p>You must not attend if you have symptoms of Covid-19, which include:</p>
        <ul>
            <li>a high temperature</li>
            <li>a new, continuous cough</li>
            <li>a loss of, or change to, your sense of smell or taste</li>
        </ul>
        <p>Please sanitise your hands regularly, and follow good hygiene practices.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleFaqsTileCovid',
};
</script>
